// 使用
// post() {
//     this.$http.home
//       .testPost({
//         aaa: 11,
//       })
//       .then((res) => {
//         this.$toast.success("请求成功");
//         console.log(res);
//       });
//   },
//   get() {
//     this.$http.home
//       .testGet({
//         aaa: 11,
//       })
//       .then((res) => {
//         this.$toast.success("请求成功");
//         console.log(res);
//       });
//   },
import {
  get,
  post
} from "../http";
const home = {
  // 获取政策列表
  getPolicyList(data) {
    return post("/461/policy/search", data);
  },
  // 获取政策类别
  getClassification(data) {
    return get("/461/policy/classification/search", data);
  },
  // 获取政策详情
  getPolicyDtl(data) {
    return get(`/461/policy/detail/${data.id}`);
  },
  // 获取标签
  getlabel(data) {
    return post('/461/open/tag/search', data);
  },
  // 获取热门
  getMatchList(data) {
    return post('/461/open/user-policy', data);
  },
};
export default home;



// WEBPACK FOOTER //
// ./src/http/api/home.js